import React from 'react'
import RemarkImage from './RemarkImage'

export default ({ srcs }) => {
  return (
    <div
      className={`mt-8 flex flex-row ${
        srcs?.length <2 ? 'justify-center' : ''
      } min-w-full overflow-x-auto`}
    >
      {srcs?.map((s, i) => (
        <RemarkImage key={i} src={s} className="flex-shrink-0  w-1/2" />
      ))}
    </div>
  )
}
